
<template>
     <a-select show-search :value="value" placeholder="输入appcode"  allow-clear 
         :default-active-first-option="false" :show-arrow="false" :filter-option="false" :not-found-content="null"
         @search="handleSearch" @change="handleChange">
         <a-select-option v-for="d in data" :key="d.value">
             {{ d.text }}
         </a-select-option>
     </a-select>
</template>
<script>

export default {
    data() {
        return {
            data: [],
            searchTimmer:null
        }
    },
    model:{
        prop:'value',
        event:'change'
    },
    props:{
        javaOnly:{
            type:String,
            default:''
        },
        value:String
    },

    methods: {
        handleChange(value) {
            this.$emit('change',value);
        },
        handleSearch(value) {
            let that = this;
            if(that.searchTimmer){
                clearTimeout(that.searchTimmer)
                that.searchTimmer = null;
            }
            that.searchTimmer = setTimeout(() => {
                that.doSearch(value);
                that.searchTimmer = null;
            }, 500);
        },
        doSearch(value) {
            let that = this;
            let c_params = {
                pageSize: 10,
                page: 1,
                flag: 1,
                urlparams: false,
                appcode: value,
                javaOnly:that.javaOnly
            }

            that.$store.dispatch({
                type: "servicekey/getAppList",
                params: c_params,
                showMsg: false
            }).then((res) => {
                if (res.data.success == 1) {
                    that.data = [];
                    let result = res.data.data.list;
                    if(!result){
                        return;
                    }
                    result.forEach(r => {
                        that.data.push({
                            value: r.appcode,
                            text: r.appcode,
                        });
                    });
                }
            }).catch(() => {

            });
        },
    },
   
};
</script>

<style scoped>

</style>
